import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteChurchNews,
  getChurchNews,
  restoreChurchNews,
  updateChurchNews,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditChurchNews() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateChurchNews(id, title, description, image);
      if (result) {
        navigate("/church-news/all");
      }
    } catch (error) {}
  };

  const publishChurchNews = async (id) => {
    try {
      await restoreChurchNews(id);

      navigate("/church-news/all");
    } catch (error) {}
  };
  const unPublishChurchNews = async (id) => {
    try {
      await deleteChurchNews(id);

      navigate("/church-news/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneChurchNews = async (id) => {
    try {
      const result = await getChurchNews(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.churchNewsId}
          breadCrumbLink={"Church News"}
          breadCrumbText={"Edit News"}
          goBackLink={"/church-news/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishChurchNews}
          unPublishItem={unPublishChurchNews}
          getOneItem={getOneChurchNews}
        />
      </Container>
    </>
  );
}
